import { BodyLg } from "@/domains/design/components/body-lg"
import { BodySM } from "@/domains/design/components/body-sm"
import { ZapIcon } from "@/domains/icons"
import { cn } from "@/domains/library"

type SuperVoterSizes = "normal" | "small"
export const SuperVoteLogo = ({ className, size = "normal" }: { className?: string; size?: SuperVoterSizes }) => {
  const iconSizeMap = {
    normal: 20,
    small: 16,
  }
  const iconSize = iconSizeMap[size]
  const gapSizeMap = {
    normal: "gap-1",
    small: "gap-0.5",
  }
  const gapSize = gapSizeMap[size]
  return (
    <div className={cn("flex items-center", gapSize, className)}>
      <ZapIcon size={iconSize} className="text-orange-400 fill-orange-400" />
      {size === "normal" && <BodyLg className="font-bold tracking-wide text-t100">SuperVoter™</BodyLg>}
      {size === "small" && <BodySM className="font-bold tracking-wide text-t100">SuperVoter™</BodySM>}
    </div>
  )
}
